module.exports = __webpack_public_path__ + "img/technicalSupportLeft.fb8c5422.svg";